import {
  Tabs,
  Tab,
  Box,
  Typography,
  Icon,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import {
  formatDate,
  formatMoney,
  Translator,
  useRedirect,
  useQueryParams,
} from "@itarget/shared";
import { convertPalestraJson } from "../../utils/palestraHelper";
import { useSelector } from "react-redux";
import { dateFormatTranslation } from "@itarget/shared/src/utils/format/date";
import Programming from "../Programming/Programming";
import ProgramAccordionItem from "../ProgramAccordionItem";
import ProgramingOnDemandGrouped from "../ProgramingOnDemand/ProgramingOnDemandGrouped";
import { useStyles } from "./styles";
import { useState } from "react";

function TabPanel(props) {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      className={className}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const getColorClass = (index) => {
  return index % 2 === 0 ? "even-color" : "odd-color";
};

const TabsDetailOffer = ({ tabs, settingCommerce }) => {
  const classes = useStyles();
  const { goTo } = useRedirect();
  const { get } = useQueryParams();
  const [value, setValue] = useState(0);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const defaultModule = get("defaultModule");
  const selectedLang = useSelector((state) => state.language.lang);
  const detailing = tabs.detailing && tabs.detailing[0];
  const programming = tabs?.programing;
  const amount = tabs?.amount;
  const convertedProgramming =
    detailing?.commerce_ondemand_exibicao === 1
      ? convertPalestraJson(programming)
      : [];

  let displayProgrammingTab = false;
  if (
    detailing?.commerce_ondemand_exibicao === 1 &&
    convertedProgramming?.length > 0
  ) {
    displayProgrammingTab = true;
  } else if (detailing?.commerce_ondemand_exibicao === 2 && programming) {
    displayProgrammingTab = true;
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : null);
  };

  let dateCounter = 0;

  return (
    tabs && (
      <div className={classes.detailOfferTabsContainer}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          className={classes.detailOfferTabsContainer}
          aria-label="full width tabs example"
          scrollButtons="auto"
        >
          <Tab
            icon={<Icon>cast_for_education</Icon>}
            value={0}
            label={<Translator transRef="translation.Informações" />}
          />
          {displayProgrammingTab && (
            <Tab
              icon={<Icon>table_view</Icon>}
              value={1}
              label={<Translator transRef="translation.Grade Curricular" />}
            />
          )}
          {((amount?.value && Object.values(amount.value).length > 0) ||
            detailing?.commerce_text_valores) && (
            <Tab
              icon={<Icon>attach_money</Icon>}
              value={2}
              label={<Translator transRef="translation.Valores" />}
            />
          )}
          {detailing && detailing.commerce_formato_exibicao == 2 && (
            <Tab
              icon={<Icon>cast_for_education</Icon>}
              value={3}
              label={<Translator transRef="translation.Ver programação" />}
            />
          )}
          {detailing && detailing.commerce_formato_exibicao == 3 && (
            <Tab
              icon={<Icon>cast_for_education</Icon>}
              value={3}
              onClick={() =>
                goTo(
                  `detail-ead/${detailing.centro_custo_id_out}/${detailing.aga_id}`
                )
              }
              label={<Translator transRef="translation.Ver aulas" />}
            />
          )}
        </Tabs>

        <TabPanel value={value} index={0}>
          <Typography className={classes.detailingDescription}>
            {detailing && detailing?.descritivo && (
              <div
                dangerouslySetInnerHTML={{ __html: detailing?.descritivo }}
              />
            )}
          </Typography>
          {detailing && detailing.data_venc_matricula && (
            <Typography className="detailing-date">
              <Translator transRef="translation.Período de inscrição:" />
              <span>
                {dateFormatTranslation(
                  selectedLang,
                  detailing.data_venc_matricula
                )}
              </span>
            </Typography>
          )}
        </TabPanel>

        <TabPanel
          value={value}
          index={1}
          className={classes.curriculumGridContainer}
        >
          {detailing?.commerce_ondemand_exibicao === 1 &&
            convertedProgramming &&
            convertedProgramming.map((row, index) => {
              if (row.data_atividade) dateCounter++;

              return (
                <ProgramAccordionItem
                  key={index}
                  row={row}
                  colorIndex={dateCounter}
                  getColorClass={getColorClass}
                  formatDate={formatDate}
                  expanded={expandedAccordion === index}
                  onChange={handleAccordionChange(index)}
                />
              );
            })}
          {detailing?.commerce_ondemand_exibicao === 2 && programming && (
            <ProgramingOnDemandGrouped
              groups={programming}
              selectStep={false}
              defaultModule={defaultModule}
              settingCommerce={settingCommerce}
            />
          )}
        </TabPanel>

        <TabPanel value={value} index={2}>
          <TableContainer className="table-valores" component={Paper}>
            <Table size="small" aria-label="a dense table">
              {amount?.value && Object.values(amount.value).length > 0 && (
                <TableHead>
                  <TableRow className="table-row">
                    {amount?.description &&
                      Object.keys(amount?.description).map((key) => {
                        return (
                          <TableCell
                            className="table-cell"
                            align="center"
                            key={key}
                          >
                            <Translator
                              transRef={`translation.${amount?.description[key]}`}
                            />
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
              )}
              <TableBody>
                {amount?.description &&
                  amount?.value.map((row, index) => (
                    <TableRow className="table-row" key={index + row.categoria}>
                      {Object.keys(amount?.description).map((key) => {
                        return (
                          <TableCell
                            className="table-cell"
                            align={
                              ["valor", "valor_nsocio"].includes(key)
                                ? "right"
                                : "left"
                            }
                            component="th"
                            scope="row"
                          >
                            {["valor", "valor_nsocio"].includes(key)
                              ? row[key] === "0.000"
                                ? "Cortesia"
                                : "R$ " + formatMoney.toReal(row[key])
                              : row[key]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          {detailing && detailing.commerce_text_valores && (
            <Typography
              component="legend"
              dangerouslySetInnerHTML={{
                __html: detailing.commerce_text_valores,
              }}
            ></Typography>
          )}
        </TabPanel>

        <TabPanel value={value} index={3}>
          <Programming detailing={detailing} />
        </TabPanel>
      </div>
    )
  );
};

export default TabsDetailOffer;
